import React, { useState } from "react";

// css
import * as styles from "./ToggleButton.module.css";

const ToggleButton = props => {
  const [toggleState, setToggleState] = useState("pilot_diabetes");

  const updateToggleButtonValue = e => {
    props.handleToggleButton(e.target.value);
    setToggleState(e.target.value);
  };

  return (
    <section>
      <div className={`container ${styles.toggleContainer}`}>
        <div className={`row ${styles.toggleBtnSec}`}>
          <button
            onClick={updateToggleButtonValue}
            value="pilot_diabetes"
            className={
              toggleState && toggleState === "pilot_diabetes"
                ? `col-xs-6 col-sm-6 col-md-12 col-lg-12 ${styles.toggleBtn__refer}`
                : `col-xs-6 col-sm-6 col-md-12 col-lg-12 ${styles.toggleBtn__track}`
            }
          >
            Diabetes
          </button>
          <button
            onClick={updateToggleButtonValue}
            value="pilot_pre_diabetes"
            className={
              toggleState && toggleState === "pilot_pre_diabetes"
                ? `col-xs-6 col-sm-6 col-md-12 col-lg-12 ${styles.toggleBtn__refer}`
                : `col-xs-6 col-sm-6 col-md-12 col-lg-12 ${styles.toggleBtn__track}`
            }
          >
            Pre-diabetes
          </button>
          <button
            onClick={updateToggleButtonValue}
            value="pilot_obesity"
            className={
              toggleState && toggleState === "pilot_obesity"
                ? `col-xs-6 col-sm-6 col-md-12 col-lg-12 ${styles.toggleBtn__refer}`
                : `col-xs-6 col-sm-6 col-md-12 col-lg-12 ${styles.toggleBtn__track}`
            }
          >
            Obesity
          </button>
          <button
            onClick={updateToggleButtonValue}
            value="pilot_metabolic_wellness"
            className={
              toggleState && toggleState === "pilot_metabolic_wellness"
                ? `col-xs-6 col-sm-6 col-md-12 col-lg-12 ${styles.toggleBtn__refer}`
                : `col-xs-6 col-sm-6 col-md-12 col-lg-12 ${styles.toggleBtn__track}`
            }
          >
            Metabolic Care
          </button>
          <button
            onClick={updateToggleButtonValue}
            value="pilot_pcos"
            className={
              toggleState && toggleState === "pilot_pcos"
                ? `col-xs-6 col-sm-6 col-md-12 col-lg-12 ${styles.toggleBtn__refer}`
                : `col-xs-6 col-sm-6 col-md-12 col-lg-12 ${styles.toggleBtn__track}`
            }
          >
            PMOS
          </button>
          <button
            onClick={updateToggleButtonValue}
            value="pilot_hypertension"
            className={
              toggleState && toggleState === "pilot_hypertension"
                ? `col-xs-6 col-sm-6 col-md-12 col-lg-12 ${styles.toggleBtn__refer}`
                : `col-xs-6 col-sm-6 col-md-12 col-lg-12 ${styles.toggleBtn__track}`
            }
          >
            Hypertension
          </button>
          <button
            onClick={updateToggleButtonValue}
            value="pilot_fatty_liver"
            className={
              toggleState && toggleState === "pilot_fatty_liver"
                ? `col-xs-6 col-sm-6 col-md-12 col-lg-12 ${styles.toggleBtn__refer}`
                : `col-xs-6 col-sm-6 col-md-12 col-lg-12 ${styles.toggleBtn__track}`
            }
          >
            Fatty Liver
          </button>
        </div>
      </div>
    </section>
  );
};

export default ToggleButton;
